import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@mui/material';  
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'


const SectionAccount = ({ mall }) => {
    const defaultValues = {
        bank_name: mall?.bank_name,
        bank_account: mall?.bank_account,
        use_mutongjang: mall?.use_mutongjang,
        use_wiring: mall?.use_wiring,
        payment_point: mall?.payment_point,
        payment_point_unit: mall?.payment_point_unit,
        payment_point_ratio: mall?.payment_point_ratio,
    }
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm()

    useEffect(() => {        
        reset(defaultValues)
    }, [mall])    

    const onSubmit = async (data, e) => {
        const params = JSON.stringify({
            "bank_name": data.bank_name,
            "bank_account": data.bank_account,
            "use_mutongjang": data.use_mutongjang,
            "use_wiring": data.use_wiring,
            "payment_point": data.payment_point,
            "payment_point_unit": data.payment_point_unit,
            "payment_point_ratio": data.payment_point_ratio
        });

        try {
            await apiService.put('/malls/bank', params);
            toast.success('업데이트 되었습니다.');
        } catch (error) {
            console.error(error);
        }
    }

    return (
        mall && 
        <Card>
            <CardHeader title='결제 정보' titleTypographyProps={{ variant: 'h6' }} />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} id="mallaccountform">
                    <Grid container spacing={6}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id='bank_name'>거래은행</InputLabel>
                                <Controller
                                    name='bank_name'
                                    control={control}
                                    rules={{ required: true }}
                                    renderValue={selected => (selected.length === 0 ? '' : selected)}
                                    render={({ field: { value, onChange } }) => (
                                        <Select
                                            label='거래은행'
                                            value={value || ''}
                                            onChange={onChange}
                                            labelId='bank_name'
                                            error={Boolean(errors.bank_name)}
                                            variant="standard"
                                        >
                                            <MenuItem value="">선택하세요.</MenuItem>
                                            <MenuItem value="SC제일은행">SC제일은행</MenuItem>
                                            <MenuItem value="경남은행">경남은행</MenuItem>
                                            <MenuItem value="광주은행">광주은행</MenuItem>
                                            <MenuItem value="국민은행">국민은행</MenuItem>
                                            <MenuItem value="굿모닝신한증권">굿모닝신한증권</MenuItem>
                                            <MenuItem value="기업은행">기업은행</MenuItem>
                                            <MenuItem value="농협중앙회">농협중앙회</MenuItem>
                                            <MenuItem value="농협회원조합">농협회원조합</MenuItem>
                                            <MenuItem value="대구은행">대구은행</MenuItem>
                                            <MenuItem value="대신증권">대신증권</MenuItem>
                                            <MenuItem value="대우증권">대우증권</MenuItem>
                                            <MenuItem value="동부증권">동부증권</MenuItem>
                                            <MenuItem value="동양종합금융증권">동양종합금융증권</MenuItem>
                                            <MenuItem value="메리츠증권">메리츠증권</MenuItem>
                                            <MenuItem value="미래에셋증권">미래에셋증권</MenuItem>
                                            <MenuItem value="뱅크오브아메리카(BOA)">뱅크오브아메리카(BOA)</MenuItem>
                                            <MenuItem value="부국증권">부국증권</MenuItem>
                                            <MenuItem value="부산은행">부산은행</MenuItem>
                                            <MenuItem value="산림조합중앙회">산림조합중앙회</MenuItem>
                                            <MenuItem value="산업은행">산업은행</MenuItem>
                                            <MenuItem value="삼성증권">삼성증권</MenuItem>
                                            <MenuItem value="상호신용금고">상호신용금고</MenuItem>
                                            <MenuItem value="새마을금고">새마을금고</MenuItem>
                                            <MenuItem value="수출입은행">수출입은행</MenuItem>
                                            <MenuItem value="수협중앙회">수협중앙회</MenuItem>
                                            <MenuItem value="신영증권">신영증권</MenuItem>
                                            <MenuItem value="신한은행">신한은행</MenuItem>
                                            <MenuItem value="신협중앙회">신협중앙회</MenuItem>
                                            <MenuItem value="에스케이증권">에스케이증권</MenuItem>
                                            <MenuItem value="에이치엠씨투자증권">에이치엠씨투자증권</MenuItem>
                                            <MenuItem value="엔에이치투자증권">엔에이치투자증권</MenuItem>
                                            <MenuItem value="엘아이지투자증권">엘아이지투자증권</MenuItem>
                                            <MenuItem value="외환은행">외환은행</MenuItem>
                                            <MenuItem value="우리은행">우리은행</MenuItem>
                                            <MenuItem value="우리투자증권">우리투자증권</MenuItem>
                                            <MenuItem value="우체국">우체국</MenuItem>
                                            <MenuItem value="유진투자증권">유진투자증권</MenuItem>
                                            <MenuItem value="전북은행">전북은행</MenuItem>
                                            <MenuItem value="제주은행">제주은행</MenuItem>
                                            <MenuItem value="키움증권">키움증권</MenuItem>
                                            <MenuItem value="하나대투증권">하나대투증권</MenuItem>
                                            <MenuItem value="하나은행">하나은행</MenuItem>
                                            <MenuItem value="하이투자증권">하이투자증권</MenuItem>
                                            <MenuItem value="한국씨티은행">한국씨티은행</MenuItem>
                                            <MenuItem value="한국투자증권">한국투자증권</MenuItem>
                                            <MenuItem value="한화증권">한화증권</MenuItem>
                                            <MenuItem value="현대증권">현대증권</MenuItem>
                                            <MenuItem value="홍콩상하이은행">홍콩상하이은행</MenuItem>
                                        </Select>
                                    )}
                                />
                                {errors.bank_name && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-bank_name'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='bank_account'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='은행계좌번호'
                                            id='bank_account'
                                            onChange={onChange}
                                            placeholder='회사 은행계좌번호를 입력해주세요'
                                            error={Boolean(errors.bank_account)}
                                            aria-describedby='validation-async-bank_account'
                                        />
                                    )}
                                />
                                {errors.bank_account && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-bank_account'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='use_mutongjang'
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field: { value, onChange } }) => (
                                        <FormControlLabel
                                            label='무통장입금사용'
                                            control={
                                                <Checkbox checked={Boolean(value)} onChange={onChange} name='controlled' />
                                            }
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='use_wiring'
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field: { value, onChange } }) => (
                                        <FormControlLabel
                                            label='계좌이체 결제사용'
                                            control={
                                                <Checkbox checked={Boolean(value)} onChange={onChange} name='controlled' />
                                            }
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='payment_point'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='결제 최소포인트'
                                            id='payment_point'
                                            onChange={onChange}
                                            placeholder='포인트 적용 결제 최소금액 입력해주세요'
                                            error={Boolean(errors.payment_point)}
                                            aria-describedby='validation-async-payment_point'
                                        />
                                    )}
                                />
                                {errors.payment_point && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-payment_point'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='payment_point_unit'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='결제 포인트단위'
                                            id='payment_point_unit'
                                            onChange={onChange}
                                            placeholder='결제 포인트단위 입력해주세요'
                                            error={Boolean(errors.payment_point_unit)}
                                            aria-describedby='validation-async-payment_point_unit'
                                        />
                                    )}
                                />
                                {errors.payment_point_unit && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-payment_point_unit'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='payment_point_ratio'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='포인트 적립률(%)'
                                            id='payment_point_ratio'
                                            onChange={onChange}
                                            placeholder='결제 포인트 적립률 입력해주세요'
                                            error={Boolean(errors.payment_point_ratio)}
                                            aria-describedby='validation-async-payment_point_ratio'
                                        />
                                    )}
                                />
                                {errors.payment_point_ratio && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-payment_point_ratio'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
                            <Button type="submit" form="mallaccountform" variant='contained' sx={{ mr: 4 }}>
                                수정
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default SectionAccount
